module.exports = __webpack_public_path__ + "img/seal_2.809facc3.png";